import { render } from "./NewEncounterModal.vue?vue&type=template&id=61c6f49e"
import script from "./NewEncounterModal.vue?vue&type=script&lang=js"
export * from "./NewEncounterModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__